import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export const CONVERSATION_MESSAGES_QUERY_KEY = 'conversation/{id}/messages';

export const useConversationMessagesInfiniteQuery = ({
	conversationId,
	pageSize = 25,
	enabled,
}: {
	conversationId: string;
	pageSize?: number;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.ITextMessage>>({
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { pageToken: pageParam, pageSize },
					urlPath: `conversation/${conversationId}/messages`,
				}),
				'GET'
			);
		},
		queryKey: [CONVERSATION_MESSAGES_QUERY_KEY, conversationId, pageSize],
		initialPageParam: '',
		enabled,
	});
};

export function invalidateConversationMessages(conversationId: string) {
	reactQueryClient.invalidateQueries({ queryKey: [CONVERSATION_MESSAGES_QUERY_KEY, conversationId] });
}
